export enum MedicalPlanDataTypeEnum {
    Individual = 'Individual',
    Family = 'Family',
    InNetwork = 'InNetwork',
    OutOfNetwork = 'OutOfNetwork',
    NoNetwork = 'None'
}
